export const name = {
    'en': 'LASS',
    'zh-tw': 'LASS'
};

export const fetchLASS = {
    'en': 'LASS Device [id]',
    'zh-tw': 'LASS 設備編號 [id]'
};

export const onLASSReceived = {
    'en': 'When received data from LASS',
    'zh-tw': '當收到 LASS 資料時'
};

export const parseAttrFromLASS = {
    'en': 'LASS read [attr]',
    'zh-tw': 'LASS 讀取 [attr]'
};

export const readFromLASSErr = {
    'en': `Error： Data does not exist`,
    'zh-tw': '錯誤： 資料 不存在',
};

export const tempc = {
    'en': `Temperature (C)`,
    'zh-tw': '溫度 C'
};

export const humidity = {
    'en': `Humidity`,
    'zh-tw': '濕度'
};
